module.exports = __webpack_public_path__ + "static/maxpezzali-04abffd093d8991edb2da13644e16998.png";